import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {
  faAngleLeft,
  faAngleRight,
  faCheck,
  faFileExcel,
  faMagnifyingGlass,
  faPen,
  faPenToSquare,
  faSquareCheck,
  faSquarePlus,
  faSquareXmark,
  faTrash,
  faUpload,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import {getUpdatedFieldsFormData, validateAllFormFields, formatOrganizationName} from '../../../common/utils';
import {AuthService} from '../../services/auth.service';
import {
  SalesInstallationPartnerSelectComponent
} from '../../shared/sales-installation-partner-select/sales-installation-partner-select.component';
import {OrganizationOnboardingComponent} from '../../shared/organization-onboarding/organization-onboarding.component';

@Component({
    selector: 'app-edit-organization',
    imports: [CommonModule, FontAwesomeModule, ReactiveFormsModule, FormsModule, SalesInstallationPartnerSelectComponent, OrganizationOnboardingComponent],
    templateUrl: './edit-organization.component.html',
    styleUrl: './edit-organization.component.css'
})
export class EditOrganizationComponent implements OnInit {
  activeTab: string = 'addCustomer'; // Default active tab
  orgId: number = 0;
  isEditing: Boolean = false;
  role: string = '';
    canEditOrganizationName = false;
  editOrganizationForm!: FormGroup;
  addressTypes = [
    'Hotel',
    'Airport',
    'Home',
    'Appartment',
    'Office',
    'Mall',
    'Other',
    'Fleet Yard',

  ]
  timeZones = {
    "Asia/Kolkata": "India -  Asia/Kolkata",
    "America/New_York": "USA (Eastern) - America/New_York",
    "America/Chicago": "USA (Central) - America/Chicago",
    "America/Denver": "USA (Mountain) - America/Denver",
    "America/Los_Angeles": "USA (Pacific) - America/Los_Angeles",
    "Europe/London": "UK - Europe/London",
    "Asia/Kuala_Lumpur": "Malaysia - Asia/Kuala_Lumpur",
    "Asia/Bangkok": "Thailand - Asia/Bangkok",
    "Asia/Singapore": "Singapore - Asia/Singapore",

  }
  organizationDetail: any = {};
  customerSources = [
    ['DIRECT', 'Direct'],
    ['INDIA_MART', 'IndiaMART'],
    ['WEBSITE', 'Website'],
    ['REFERENCE', 'Reference'],
    ['SALES_INSTALLATION_PARTNER', 'Sales & Installation Partner'],
    ['OTHER', 'Other'],
  ];
  installationOptions = [
    ['KYRA_TEAM', 'Kyra Team'],
    ['SALES_INSTALLATION_PARTNER', 'Sales & Installation Partner'],
    ['CUSTOMER_TEAM', 'Customer Team'],
    ['OTHER_VENDOR', 'Other Vendor'],
  ];
  pk: any;
  formChanged: Boolean = false;
  fieldMapping: any = {
    name: "name",
    pincode: 'address.pincode',
    city: 'address.city',
    state: 'address.state',
    locality: 'address.locality',
    flatBuildingName: 'address.flat_building_name',
    landmark: 'address.landmark',
    addressType: 'address.address_type',
    isDefault: 'address.is_default',
    customer_source: 'customer_source',
    source_sales_installation_partner: 'source_sales_installation_partner',
    installation_by: 'installation_by',
    installation_sales_installation_partner: 'installation_sales_installation_partner'
  }


  constructor(private apiService: ApiService,
    library: FaIconLibrary,
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService) {

    library.addIcons(faTrash,
      faFileExcel,
      faAngleRight,
      faAngleLeft,
      faUpload,
      faSquarePlus,
      faMagnifyingGlass,
      faPen,
      faPenToSquare,
      faXmark,
      faCheck,
      faSquareCheck,
      faSquareXmark
    );

    // const navigation = this.router.getCurrentNavigation();
    // let staffTab = navigation?.extras.state?.['activeTab'];
    // if (staffTab){
    //   this.activeTab = staffTab
    // }


    this.editOrganizationForm = this.fb.group({
      name: ['', Validators.required],
      pincode: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      locality: ['', Validators.required],
      flatBuildingName: ['', Validators.required],
      landmark: [''],
      addressType: ['', Validators.required],
      isDefault: ['', Validators.required],
      timezone: ['', Validators.required],
      customer_source: [''],
      source_sales_installation_partner: [null],
      installation_by: [''],
      installation_sales_installation_partner: [null]
    });

  }

  ngOnInit(): void {
    // Get pk id from url
    this.getUserRole();
    this.pk = this.route.snapshot.paramMap.get('pk');
    if (this.pk) {
      this.getOrganization(this.pk);
    } else if (this.orgId) {
      this.getOrganization(this.orgId);
    }
  }

  getUserRole() {
    let userInfo = localStorage.getItem('user');
    if (userInfo) {
      const userObj = JSON.parse(userInfo)
        this.orgId = userObj['org_id'] ?? userObj['orgId']
      this.role = userObj['groups']
        this.canEditOrganizationName = this.authService.isSuperUser();
    }
  }

  getOrganization(pk: any) {
      if (!pk) {
          return;
      }
    this.apiService.getOrganization(pk).subscribe({
      next: (response: any) => {
          this.organizationDetail = response;

        this.editOrganizationForm = this.fb.group({
          name: [this.organizationDetail.name, Validators.required],
          pincode: [this.organizationDetail.address.pincode, Validators.required],
          city: [this.organizationDetail.address.city, Validators.required],
          state: [this.organizationDetail.address.state, Validators.required],
          locality: [this.organizationDetail.address.locality, Validators.required],
          flatBuildingName: [this.organizationDetail.address.flat_building_name, Validators.required],
          landmark: [this.organizationDetail.address.landmark],
          addressType: [this.organizationDetail.address.address_type, Validators.required],
          isDefault: [this.organizationDetail.address.is_default, Validators.required],
          timezone: [this.organizationDetail.timezone, Validators.required],
          customer_source: [this.organizationDetail.customer_source || ''],
          source_sales_installation_partner: [this.organizationDetail.source_sales_installation_partner || null],
          installation_by: [this.organizationDetail.installation_by || ''],
          installation_sales_installation_partner: [this.organizationDetail.installation_sales_installation_partner || null]
        });
        this.setupPartnerFieldHandlers();
          this.editOrganizationForm.valueChanges.subscribe(() => {
          this.checkFormChanges();
        });
      },
      error: (err) => {
        if (err['error']['non_field_errors']) {
          err['error']['non_field_errors'].forEach((element: any) => {
            this.toastr.error(element, 'Error');
          });
        }
      }
    });
  }

  onPincodeChange() {
    const pincode = this.editOrganizationForm.get('pincode')?.value;

    if (pincode && pincode.length === 6) { // Adjust length validation based on your region
      this.fetchCityState(pincode);
    }
  }

  fetchCityState(pincode: number) {
    this.apiService.getCityState(pincode).subscribe({
      next: (data: any) => {
        if (data.length > 0) {
          data = data[0]
          this.editOrganizationForm.patchValue({
            city: data.district_name,
            state: data.state_name,
            // locality: data.village_or_locality_name,
          });
          // Mark the fields as dirty
          this.editOrganizationForm.get('city')?.markAsDirty();
          this.editOrganizationForm.get('state')?.markAsDirty();

        }


      },
      error: (err) => {
        if (err['error']['detail']) {
          this.toastr.error(err['error']['detail'], 'Error')
        }
      }
    });
  }

  onSubmit() {
    if (this.organizationDetail.id && this.editOrganizationForm.valid) {
      // let formData = new FormData();
      // formData.append('name', this.editOrganizationForm.value.name.toUpperCase())
      // formData.append('address.pincode', this.editOrganizationForm.value.pincode)
      // formData.append('address.city', this.editOrganizationForm.value.city)
      // formData.append('address.state', this.editOrganizationForm.value.state)
      // formData.append('address.locality', this.editOrganizationForm.value.locality)
      // formData.append('address.flat_building_name', this.editOrganizationForm.value.flatBuildingName)
      // formData.append('address.landmark', this.editOrganizationForm.value.landmark)
      // formData.append('address.address_type', this.editOrganizationForm.value.addressType)
      // formData.append('address.is_default', this.editOrganizationForm.value.isDefault)
      // formData.append('address.country', 'India')
      // formData.append('is_active', "true")
      let updatedFields = getUpdatedFieldsFormData(this.editOrganizationForm, this.fieldMapping);
        if (this.editOrganizationForm.get('name')?.dirty) {
            updatedFields.set('name', formatOrganizationName(this.editOrganizationForm.value.name));
        }
      this.apiService.editOrganization(this.organizationDetail.id, updatedFields).subscribe({
        next: (res: any) => {
          this.toastr.success("Customer Updated Successfully", 'Success');
          this.redirect()

          // this.router.navigate(['organization'], {state: {'activeTab': 'customers'}})

        },
        error: (err) => {
          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element: any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['error']['name']) {
            err['error']['name'].forEach((element: any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error("Something went wrong!", 'Error');
          }
        }
      })

    } else {
      validateAllFormFields(this.editOrganizationForm)
    }
  }

  redirect() {
    if (this.route.snapshot.paramMap.get('pk')) {
      this.router.navigate(['organization'], { state: { 'activeTab': 'customer' } })

    } else {
      this.router.navigate(['organization'], { state: { 'activeTab': 'organization' } })
    }
  }

  onCancel() {
    this.redirect()
    // this.router.navigate(['organization'], {state: {'activeTab': 'customers'}})

  }

  checkFormChanges() {
    if (!this.organizationDetail) return;

    const formValue = this.editOrganizationForm.value;
    this.formChanged =
      formValue.name !== this.organizationDetail.name ||
      formValue.pincode !== this.organizationDetail.address.pincode ||
      formValue.city !== this.organizationDetail.address.city ||
      formValue.state !== this.organizationDetail.address.state ||
      formValue.locality !== this.organizationDetail.address.locality ||
      formValue.flatBuildingName !== this.organizationDetail.address.flat_building_name ||
      formValue.landmark !== this.organizationDetail.address.landmark ||
      formValue.addressType !== this.organizationDetail.address.address_type ||
      formValue.isDefault !== this.organizationDetail.address.is_default ||
      formValue.timezone !== this.organizationDetail.timezone ||
      formValue.customer_source !== (this.organizationDetail.customer_source || '') ||
      formValue.source_sales_installation_partner !== (this.organizationDetail.source_sales_installation_partner || null) ||
      formValue.installation_by !== (this.organizationDetail.installation_by || '') ||
      formValue.installation_sales_installation_partner !== (this.organizationDetail.installation_sales_installation_partner || null);

  }

  get showSourcePartnerField(): boolean {
    return this.editOrganizationForm.get('customer_source')?.value === 'SALES_INSTALLATION_PARTNER';
  }

  get showInstallationPartnerField(): boolean {
    return this.editOrganizationForm.get('installation_by')?.value === 'SALES_INSTALLATION_PARTNER';
  }

  setSourcePartner(partnerId: number | null): void {
    const control = this.editOrganizationForm.get('source_sales_installation_partner');
    control?.setValue(partnerId);
    control?.markAsDirty();
    control?.markAsTouched();
  }

  setInstallationPartner(partnerId: number | null): void {
    const control = this.editOrganizationForm.get('installation_sales_installation_partner');
    control?.setValue(partnerId);
    control?.markAsDirty();
    control?.markAsTouched();
  }

  private setupPartnerFieldHandlers(): void {
    this.editOrganizationForm.get('customer_source')?.valueChanges.subscribe((value) => {
      if (value !== 'SALES_INSTALLATION_PARTNER' && this.editOrganizationForm.get('source_sales_installation_partner')?.value) {
        this.editOrganizationForm.patchValue({ source_sales_installation_partner: null }, { emitEvent: false });
      }
    });

    this.editOrganizationForm.get('installation_by')?.valueChanges.subscribe((value) => {
      if (value !== 'SALES_INSTALLATION_PARTNER' && this.editOrganizationForm.get('installation_sales_installation_partner')?.value) {
        this.editOrganizationForm.patchValue({ installation_sales_installation_partner: null }, { emitEvent: false });
      }
    });
  }


}
